import refreshTokens from "./refreshTokens";
export const tokensRefreshmentApiReducers = {
  refreshTokens
};